import React from "react";

import { Button, Link, Page } from "@samskip/frontend-components";
import { useTranslation } from "react-i18next";

import { constructMainServiceWebLink } from "@assets/utilities/navMenuUtilities";

import notFoundIMG from "../assets/images/404.png";

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <Page fitContent size="small">
      <div className="flex flex-col gap-8 justify-center items-center">
        <img alt="404 Not Found" src={notFoundIMG} />
        <h1 className="text-base">{t("TEXT_NOT_FOUND_PAGE")}</h1>
        <Link href={constructMainServiceWebLink("")}>
          <Button variant="secondary">{t("LABEL_GO_MY_PAGE")}</Button>
        </Link>
      </div>
    </Page>
  );
};

export default NotFound;
